import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const LocationSearchGlyph = /*#__PURE__*/createElement("g", {
  id: "planetSearch",
  transform: "scale(2.5)",
  fill: "none",
  strokeWidth: "1.5px"
}, /*#__PURE__*/createElement("path", {
  d: "M0.994572 15H10.05C11.25 15 12.45 15.45 13.2 16.35L15 18C16.65 19.65 16.8 22.35 15.15 24.15L13.05 26.4C12.3 27.15 11.85 28.35 11.85 29.4V34.05M30.2891 6H21.6C19.8 6 18.3 7.5 18.3 9.3C18.3 11.1 19.8 12.75 21.6 12.75H22.2C23.7 12.75 25.05 13.5 25.95 14.7L27 16.5M30.4869 30.4881L35.25 35.25M21.3964 34.8254C14.3214 36.2428 7.16197 33.2067 3.3 27C-0.900004 20.25 0.149996 11.55 5.7 5.85C11.25 0.15 19.95 -0.9 26.7 3.15C33.0306 6.94838 36.3266 14.3092 34.7319 21.52M26.25 32.25C29.55 32.25 32.25 29.55 32.25 26.25C32.25 22.95 29.55 20.25 26.25 20.25C22.95 20.25 20.25 22.95 20.25 26.25C20.25 29.55 22.95 32.25 26.25 32.25Z",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));
const LocationSearch = createSvg({
  name: 'locationSearch',
  path: LocationSearchGlyph
});

export default LocationSearch;
export { LocationSearchGlyph };
